import React from 'react';
import type { AppProps } from './AppProps';

export type AppConfig = Omit<
    AppProps,
    'isProbablyMobile' | 'searchPlaceholder' | 'searchTerm'
>;

export const AppConfigContext = React.createContext<AppConfig | undefined>(
    void 0,
);

type AppConfigProviderProps = AppConfig & {
    children: React.ReactNode;
};

export function AppConfigProvider(props: AppConfigProviderProps) {
    const {
        actionUrl,
        apiUrl,
        children,
        isLandingPage,
        locale,
        searchKey,
        siteUrl,
        vertical,
        where,
    } = props;

    const value = React.useMemo<AppConfig>(
        () => ({
            actionUrl,
            apiUrl,
            isLandingPage,
            locale,
            searchKey,
            siteUrl,
            vertical,
            where,
        }),
        [
            actionUrl,
            apiUrl,
            isLandingPage,
            locale,
            searchKey,
            siteUrl,
            vertical,
            where,
        ],
    );

    return (
        <AppConfigContext.Provider value={value}>
            {children}
        </AppConfigContext.Provider>
    );
}

export function useAppConfig() {
    const context = React.useContext(AppConfigContext);
    if (typeof context === 'undefined') {
        throw new Error(
            'useAppConfig must be used within an AppConfigProvider',
        );
    }
    return context;
}
